export default __webpack_public_path__ + "static/media/chocolateMudMuffin.959f8811.jpeg";